import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@/ui/Button/Button";
import { getBloggerCompetition } from "@/api/base";
import { useUserInfoStore } from "@/store/userInfoStore";
import { BloggerCompetition } from "@/types/referals";
import coinRuble from "@/assets/coin_ruble.webp";

import cls from "./styles.module.scss";

const getBannerCopy = (competition: BloggerCompetition, daysLeft: number) => {
  switch (competition.state) {
    case "waiting_results":
      return {
        badge: "Конкурс завершён",
        title: "Подводим итоги конкурса",
      };
    case "results":
      return {
        badge: "Итоги подведены",
        title: "Итоги конкурса",
      };
    case "active":
    default:
      return {
        badge: `До конца ${daysLeft} дн.`,
        title: "Конкурс для блогеров",
      };
  }
};

export const BloggerContestBanner = () => {
  const navigate = useNavigate();
  const yandexId = useUserInfoStore((state) => state.yandexId);
  const serviceType = useUserInfoStore((state) => state.serviceType);
  const [competition, setCompetition] = useState<BloggerCompetition | null>(
    null
  );

  useEffect(() => {
    if (!yandexId || !serviceType) return;

    let isCancelled = false;
    getBloggerCompetition(yandexId, serviceType)
      .then((response) => {
        if (!isCancelled) setCompetition(response.competition);
      })
      .catch(() => {
        if (!isCancelled) setCompetition(null);
      });

    return () => {
      isCancelled = true;
    };
  }, [yandexId, serviceType]);

  if (!competition) return null;

  const daysLeft = Math.max(
    0,
    Math.ceil(
      (new Date(competition.registrations_end_at).getTime() - Date.now()) /
        86400000
    )
  );
  const copy = getBannerCopy(competition, daysLeft);

  return (
    <div className={cls.banner}>
      <span className={cls.badge}>{copy.badge}</span>
      <img className={cls.coin} src={coinRuble} alt="" aria-hidden="true" />
      <span className={cls.content}>
        <strong>{copy.title}</strong>
        <span className={cls.description}>
          Снимай ролики, приводи рефералов
        </span>
      </span>
      <Button
        trigger="ref.contest.open"
        className={cls.action}
        label={
          <>
            Посмотреть рейтинг <b>›</b>
          </>
        }
        onClick={() => navigate("/blogger-contest")}
      />
    </div>
  );
};
